<script setup lang="ts">
import type { ResourceRef } from '@/lib/resource-links'
import { canonicalResourceType } from '@/lib/resource-links'
import TaskPreview from './TaskPreview.vue'
import RunPreview from './RunPreview.vue'
import JobPreview from './JobPreview.vue'
import JobRunPreview from './JobRunPreview.vue'
import GenericPreview from './GenericPreview.vue'

defineProps<{
  resourceRef: ResourceRef
}>()

// Keyed by canonical type — refs may arrive with plural/kebab variants
// (server path segments), which canonicalResourceType folds together.
const previewMap: Record<string, typeof TaskPreview> = {
  task: TaskPreview,
  run: RunPreview,
  job: JobPreview,
  job_run: JobRunPreview,
}

function previewComponent(type: string) {
  return previewMap[canonicalResourceType(type)] ?? GenericPreview
}
</script>

<template>
  <component :is="previewComponent(resourceRef.type)" :resource-ref="resourceRef" />
</template>
